import { render, staticRenderFns } from "./MyPolicies.vue?vue&type=template&id=37c61ee0&scoped=true"
import script from "./MyPolicies.vue?vue&type=script&lang=js"
export * from "./MyPolicies.vue?vue&type=script&lang=js"
import style0 from "./MyPolicies.vue?vue&type=style&index=0&id=37c61ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c61ee0",
  null
  
)

export default component.exports